module.exports = __webpack_public_path__ + "img/aman.13d44921.png";